module.exports = __webpack_public_path__ + "assets/img/10分钟集成.23802183.jpg";